const bridge = () => typeof window !== "undefined" ? window.desktopOfflineKots : null;

const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline KOTs.");
  return api;
};

const cleanError = (error) => {
  const message = String(error?.message || error || "Offline KOT operation failed.")
    .replace(/^Error invoking remote method '[^']+':\s*(?:Error:\s*)?/i, "")
    .replace(/^Error:\s*/i, "")
    .trim();
  return new Error(message || "Offline KOT operation failed.");
};

const invoke = async (operation) => {
  try { return await operation(); }
  catch (error) { throw cleanError(error); }
};

export const createOfflineKot = (payload) => invoke(() => requireBridge().create(payload));

export const listOfflineKots = (restaurantId, status, fromDate, toDate, waiterId = "") =>
  invoke(() => requireBridge().list({ restaurantId, status, fromDate, toDate, waiterId }));

export const getOfflineKotCounts = (restaurantId, fromDate, toDate) =>
  invoke(() => requireBridge().counts({ restaurantId, fromDate, toDate }));

export const updateOfflineKotStatus = (restaurantId, itemId, status) =>
  invoke(() => requireBridge().updateStatus({ restaurantId, itemId, status }));

export const deleteOfflineKotItem = (restaurantId, itemId) =>
  invoke(() => requireBridge().remove({ restaurantId, itemId }));
